import { render, staticRenderFns } from "./ShoppingCartButton.vue?vue&type=template&id=53c5bd90&"
import script from "./ShoppingCartButton.vue?vue&type=script&lang=ts&"
export * from "./ShoppingCartButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports